import { css } from 'emotion';
import * as React from 'react';

import { notificationRed } from '../../../../styles/colors';
import { toCurrency, displayAmount } from '../../../../helpers/currency';

interface Props {
  className?: string;
  maxLength?: number;
  value: number;
  onChange: (value: number) => void;
  required?: boolean;
  min?: number;
  max?: number;
}

const error = css`
  color: ${notificationRed};
  font-size: 11px;
`;

export class CurrencyInput extends React.Component<Props> {
  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const valueMask = toCurrency(event.target.value);
    this.props.onChange(Number(valueMask));
  };

  mask = (value: number) => {
    return value.toLocaleString(undefined, {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
      style: 'decimal',
    });
  };

  render() {
    return (
      <div>
        <input
          type="text"
          placeholder="0.00"
          value={this.mask(this.props.value)}
          onChange={this.handleChange}
          maxLength={this.props.maxLength || 10}
          className={this.props.className}
          required={!!this.props.required}
        />
        {this.props.min && this.props.value < this.props.min && (
          <span className={error}>Payment amount must be at least {displayAmount(this.props.min)}</span>
        )}
        {this.props.max && this.props.value > this.props.max && (
          <span className={error}>
            Payment amount must be less than requested amount.
          </span>
        )}
      </div>
    );
  }
}
